import { render, staticRenderFns } from "./PaymentAdd.vue?vue&type=template&id=ca027244&scoped=true"
import script from "./PaymentAdd.vue?vue&type=script&lang=js"
export * from "./PaymentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca027244",
  null
  
)

export default component.exports